import { render, staticRenderFns } from "./GroupElement.vue.js?vue&type=template&id=089f5dc9&scoped=true!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GroupElement.vue?vue&type=template&id=089f5dc9&scoped=true"
import script from "./GroupElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GroupElement.vue?vue&type=script&lang=js"
export * from "./GroupElement.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./GroupElement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089f5dc9",
  null
  
)

export default component.exports